export const QUERY_KEYS = {
    gifs: 'gifs',
    search_gifs: 'search_gifs'
}
